<template>
  <v-sheet color="bgtopology" class="ma-4 defaultCard clean-tech-container">
    <!-- Header Superior / Título -->
    <v-row class="mb-1 align-center justify-space-between px-4 pt-2">
      <div>
        <h1 class="titlePages text-h5 font-weight-bold text-white mb-0">
          {{ t('title.monitoring') }}
        </h1>
        <p class="text-caption text-grey-lighten-1 mb-0">
          Visualización de Equipos y Estado de Red
        </p>
      </div>

      <!-- Acciones de Menú / Selector de Columnas -->
      <v-menu location="bottom end">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            icon="mdi-menu"
            variant="text"
            color="grey-lighten-2"
            density="comfortable"
            class="clean-menu-btn"
          ></v-btn>
        </template>
        <v-list nav class="clean-menu-list">
          <v-list-item
            v-for="(item, i) in itemsColumns"
            :key="i"
            :value="item.value"
            :title="item.title"
            class="nav_item_title"
            :disabled="item.disabled"
            link
            @click="showDialog(item.value)"
          >
            <template v-slot:prepend>
              <v-icon size="small" :color="item.value === 1 ? 'cyan-accent-2' : 'red-lighten-2'">
                {{ item.value === 1 ? 'mdi-table-column-plus-after' : 'mdi-table-column-remove' }}
              </v-icon>
            </template>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-row>

    <!-- Tabla de Datos -->
    <v-data-table
      v-if="sortedItems.length > 0"
      :headers="ALLHEADER"
      :items="sortedItems"
      table-class-name="customize-table clean-table"
      :hide-footer="sortedItems.length < 5"
      density="compact"
    >
      <!-- Cabecera Arrastrable (VueDraggableNext) -->
      <template v-slot:headers>
        <VueDraggableNext
          class="dragArea list-group w-full clean-header-row"
          :list="ALLHEADER"
          tag="tr"
          @change="changeHeader(ALLHEADER)"
        >
          <td
            v-for="(item, i) in ALLHEADER"
            :key="item.key ?? i"
            @click="sortBy(item.key)"
            class="clean-th"
          >
            <div class="d-flex align-center gap-1 justify-space-between">
              <span class="clean-th-text">{{ item.title?.toUpperCase() }}</span>
              <span v-if="sortKey === item.key" class="clean-sort-icon">
                {{ sortDesc ? '▼' : '▲' }}
              </span>
            </div>
          </td>
        </VueDraggableNext>
      </template>

      <!-- Renderizado Personalizado por Fila / Celdas -->
      <template v-slot:item="{ item }">
        <tr class="monitoreoTR clean-tr" @click="postURL(item)">
          <td v-for="(header, i) in ALLHEADER" :key="i" class="clean-td">
            
            <!-- 1. Estado (Chips / Badges con luz suave) -->
            <template v-if="header.key === 'status'">
              <span :class="getStatusChipClass(item.status)" class="clean-chip">
                <span class="dot"></span>
                {{ item.status || 'N/A' }}
              </span>
            </template>

            <!-- 2. Dirección IP (Tipografía Mono-espaciada) -->
            <template v-else-if="header.key === 'ip'">
              <span class="clean-ip-text">{{ item.ip }}</span>
            </template>

            <!-- 3. IMEI / Identificadores (Resaltado en Negrita) -->
            <template v-else-if="header.key === 'imei'">
              <span class="font-weight-bold text-white">{{ item.imei }}</span>
            </template>

            <!-- 4. RSRQ (Con Mini Indicador Visual de Cobertura) -->
            <template v-else-if="header.key === 'rsrq'">
              <div class="d-inline-flex align-center gap-1">
                <span>{{ item[header.key] }}</span>
                <v-icon
                  size="x-small"
                  :color="getSignalColor(item[header.key])"
                  class="ml-1"
                >
                  mdi-signal-cellular-3
                </v-icon>
              </div>
            </template>

            <!-- 5. Demás celdas (Texto estándar) -->
            <template v-else>
              <span class="clean-cell-text">{{ item[header.key] ?? '-' }}</span>
            </template>

          </td>
        </tr>
      </template>
    </v-data-table>

    <!-- Indicador de Carga -->
    <v-row v-else justify="center" class="ma-4 pa-8">
      <Prog_circular />
    </v-row>

    <v-divider thickness="1" color="white" opacity="0.1" class="mt-4 mb-4"></v-divider>
  </v-sheet>

  <!-- Diálogo para Agregar Columna -->
  <v-dialog v-model="dialog" width="450px">
    <v-card class="clean-dialog pa-4">
      <v-card-title class="clean-dialog-title d-flex align-center gap-2 px-0 pt-0">
        <v-icon color="cyan-accent-2">mdi-table-column-plus-after</v-icon>
        <span>Agregar Columna</span>
      </v-card-title>

      <v-card-text class="px-0 py-3">
        <v-row density="compact">
          <v-col cols="12" class="mb-2">
            <v-text-field
              hide-details
              density="compact"
              variant="outlined"
              v-model="textColumn"
              label="Nombre Columna"
              color="cyan-accent-2"
              class="clean-input"
            />
          </v-col>
          <v-col cols="12">
            <v-select
              hide-details
              density="compact"
              variant="outlined"
              v-model="columnSelected"
              :items="columnsList"
              label="Valor Columna"
              color="cyan-accent-2"
              class="clean-input"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="px-0 pb-0">
        <v-spacer></v-spacer>
        <v-btn variant="text" color="grey-lighten-1" @click="dialog = false">Cancelar</v-btn>
        <v-btn
          color="cyan-accent-2"
          variant="flat"
          class="text-black font-weight-bold"
          @click="agregarColumna"
          :disabled="textColumn === '' || columnSelected === ''"
        >
          Agregar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Diálogo para Eliminar Columna -->
  <v-dialog v-model="dialogDelete" width="450px">
    <v-card class="clean-dialog pa-4">
      <v-card-title class="clean-dialog-title d-flex align-center gap-2 px-0 pt-0">
        <v-icon color="red-lighten-2">mdi-table-column-remove</v-icon>
        <span>Eliminar Columna</span>
      </v-card-title>

      <v-card-text class="px-0 py-3">
        <v-select
          hide-details
          density="compact"
          variant="outlined"
          v-model="columnSelected"
          :items="allColumnsList"
          label="Seleccionar Columna a Eliminar"
          color="cyan-accent-2"
          class="clean-input"
        />
      </v-card-text>

      <v-card-actions class="px-0 pb-0">
        <v-spacer></v-spacer>
        <v-btn variant="text" color="grey-lighten-1" @click="dialogDelete = false">Cancelar</v-btn>
        <v-btn
          color="red-lighten-1"
          variant="flat"
          class="text-white font-weight-bold"
          @click="eliminarColumna"
          :disabled="columnSelected === ''"
        >
          Eliminar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, Ref, onMounted, onUnmounted, computed } from 'vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTAPIS from '@/constants/apis';
import { MONITOREO } from '@/constants/monitoring';

/********************************
 ********** COMPONENTS **********
 *******************************/
import { VueDraggableNext } from 'vue-draggable-next';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { ALLHEADERFIX, HEADERFIX } from '@/interfaces/SmartLink/Tables';
import { MONITORING } from '@/interfaces/GestorHCGLINK/Equips';
import { STRINGS } from '@/interfaces/SmartLink/General';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 *********** FUNCTION ***********
 *******************************/
import { getInfoByIP } from '@/functions/project';

const sortKey = ref('');
const sortDesc = ref(false);

function sortBy(key: string) {
  if (sortKey.value === key) {
    sortDesc.value = !sortDesc.value;
  } else {
    sortKey.value = key;
    sortDesc.value = false;
  }
}

// Clase para estilos de los chips de estado
const getStatusChipClass = (status: string) => {
  if (status === 'connected' || status === 'online') {
    return 'status-connected';
  }
  if (status === 'searching' || status === 'connecting') {
    return 'status-searching';
  }
  return 'status-disconnected';
};

// Color dinámico para íconos de señal RSRQ
const getSignalColor = (val: string) => {
  if (!val) return 'grey';
  const num = parseInt(val);
  if (num >= -7) return 'teal-accent-3';
  if (num >= -10) return 'amber-accent-2';
  return 'red-accent-2';
};

// Computada para ordenar items
const sortedItems = computed(() => {
  if (!sortKey.value) return arrayOfObjects.value;

  return [...arrayOfObjects.value].sort((a, b) => {
    const aVal = a[sortKey.value];
    const bVal = b[sortKey.value];

    if (aVal == null) return 1;
    if (bVal == null) return -1;

    if (aVal === bVal) return 0;
    if (sortDesc.value) {
      return aVal < bVal ? 1 : -1;
    } else {
      return aVal > bVal ? 1 : -1;
    }
  });
});

const postURL = (item: any) => {
  window.open(`http://${item.ip}/webfig/#interfaces`, '_blank', 'noopener,noreferrer');
};

const HEADERS: Ref<ALLHEADERFIX> = ref({
  principal: [
    { title: 'status', key: 'status', sortable: true },
    { title: 'name', key: 'name', sortable: true },
    { title: 'ip', key: 'ip', sortable: true },
    { title: 'tipo', key: 'tipo', sortable: true },
    { title: 'imei', key: 'imei', sortable: true },
    { title: 'Primary Band', key: 'primary-band', sortable: true },
    { title: 'DL Modulation', key: 'dl-modulation', sortable: true },
    { title: 'CQI', key: 'cqi', sortable: true },
    { title: 'RI', key: 'ri', sortable: true },
    { title: 'MCS', key: 'mcs', sortable: true },
    { title: 'rssi (dBm)', key: 'rssi', sortable: true },
    { title: 'rsrp (dBm)', key: 'rsrp', sortable: true },
    { title: 'rsrq (dB)', key: 'rsrq', sortable: true },
    { title: 'sinr (dB)', key: 'sinr', sortable: true },
    { title: 'APN', key: 'apn-profiles', sortable: true },
    { title: 'network-mode', key: 'network-mode', sortable: true },
    { title: 'uptime', key: 'session-uptime', sortable: true },
    { title: 'enb-id', key: 'enb-id', sortable: true },
    { title: 'phy-cellid', key: 'phy-cellid', sortable: true },
  ],
  secundary: [{ title: 'phy-cellid', key: 'phy-cellid', sortable: true }],
});

const columnsList: Ref<string[]> = ref([]);
const allColumnsList: Ref<string[]> = ref([]);
const columnSelected = ref('');
const textColumn = ref('');

const ALLHEADER: Ref<HEADERFIX[]> = ref(HEADERS.value.principal);

const changeHeader = (header: Array<HEADERFIX>) => {
  ALLHEADER.value = header;
  getAllColumnsList();
};

const itemsColumns = ref([
  { title: 'Agregar Columnas', value: 1, disabled: computed(() => columnsList.value.length === 0) },
  { title: 'Eliminar Columnas', value: 2, disabled: computed(() => allColumnsList.value.length === 0) },
]);

const agregarColumna = () => {
  ALLHEADER.value.push({
    title: textColumn.value ?? 'Texto Default',
    key: columnSelected.value,
    sortable: true,
  });
  columnsList.value = columnsList.value.filter((item) => item !== columnSelected.value);
  textColumn.value = '';
  columnSelected.value = '';
  dialog.value = false;
  getAllColumnsList();
};

const eliminarColumna = () => {
  ALLHEADER.value = ALLHEADER.value.filter((item: HEADERFIX) => item.key !== columnSelected.value);
  columnsList.value.push(columnSelected.value);
  columnSelected.value = '';
  dialogDelete.value = false;
  getAllColumnsList();
};

const dialog = ref(false);
const dialogDelete = ref(false);
const showDialog = (valor: number) => {
  if (valor === 1) dialog.value = true;
  if (valor === 2) dialogDelete.value = true;
};

const arrayOfObjects = ref<any[]>(MONITOREO);

const getAllColumnsList = () => {
  allColumnsList.value = [];
  ALLHEADER.value.forEach((item: HEADERFIX) => {
    allColumnsList.value.push(item.key);
  });
};

onMounted(async () => {
  getAllColumnsList();
});
</script>

<style scoped>
/* Contenedor Principal "Clean Modern Tech" */
.clean-tech-container {
  background-color: #1a1e2b !important;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

/* Cabecera de Tabla */
.clean-header-row {
  background-color: rgba(255, 255, 255, 0.04);
}

.clean-th {
  padding: 12px 14px !important;
  color: #94a3b8 !important;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.6px;
  cursor: grab;
  user-select: none;
  white-space: nowrap;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  transition: background 0.2s ease, color 0.2s ease;
}

.clean-th:hover {
  background-color: rgba(255, 255, 255, 0.08);
  color: #ffffff !important;
}

.clean-sort-icon {
  font-size: 0.65rem;
  color: #38bdf8;
}

/* Filas y Celdas */
.clean-tr {
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
  transition: all 0.2s ease;
}

.monitoreoTR:hover {
  cursor: pointer;
  background-color: rgba(56, 189, 248, 0.06) !important;
  box-shadow: inset 0 0 0 1px rgba(56, 189, 248, 0.25);
  border-radius: 4px;
}

.clean-td {
  padding: 10px 14px !important;
  font-size: 0.81rem;
  white-space: nowrap;
  color: #cbd5e1;
}

.clean-ip-text {
  font-family: 'Fira Code', monospace, sans-serif;
  color: #38bdf8;
}

/* Estilos de Badges / Chips de Estado */
.clean-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.72rem;
  font-weight: 500;
  text-transform: lowercase;
}

.clean-chip .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

/* Estado: Connected */
.status-connected {
  background: rgba(16, 185, 129, 0.12);
  color: #34d399;
  border: 1px solid rgba(52, 211, 153, 0.3);
}
.status-connected .dot {
  background-color: #34d399;
  box-shadow: 0 0 6px #34d399;
}

/* Estado: Searching */
.status-searching {
  background: rgba(245, 158, 11, 0.12);
  color: #fbbf24;
  border: 1px solid rgba(251, 191, 36, 0.3);
}
.status-searching .dot {
  background-color: #fbbf24;
  box-shadow: 0 0 6px #fbbf24;
}

/* Estado: Disconnected */
.status-disconnected {
  background: rgba(239, 68, 68, 0.12);
  color: #f87171;
  border: 1px solid rgba(248, 113, 113, 0.3);
}
.status-disconnected .dot {
  background-color: #f87171;
}

/* Menú & Diálogos */
.clean-menu-list {
  background-color: #1e2433 !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
}

.clean-dialog {
  background-color: #1e2433 !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
}

.clean-dialog-title {
  color: #ffffff;
}

.gap-1 {
  gap: 4px;
}
.gap-2 {
  gap: 8px;
}
</style>